module.exports = __webpack_public_path__ + "static/img/3.81c70d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/3.png
// module id = XncC
// module chunks = 0